import Lesson from './lesson'

export default class CourseLesson {
  readonly id: number
  readonly lesson: Lesson
  isLearnt: boolean
  unlockDate: string | null
  isLocked: boolean
  videoLastPosition: number

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.lesson = new Lesson(data.lesson)
    this.isLearnt = data.isLearnt
    this.unlockDate = data.unlockDate || data.unlock_date || null
    this.isLocked = data.isLocked !== undefined ? data.isLocked : (data.is_locked || false)
    this.videoLastPosition = data.videoLastPosition || data.video_last_position || 0
  }

  get formattedUnlockDate(): string | null {
    if (!this.unlockDate) return null
    const date = new Date(this.unlockDate)
    const hours = date.getHours().toString().padStart(2, '0')
    const minutes = date.getMinutes().toString().padStart(2, '0')
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${hours}:${minutes}`
  }
}
